import { Box, AlertTriangle } from 'lucide-react';
import { Badge } from '../ui/badge';

export default function InventoryTab({ inventory }) {
  const getStockStatus = (item) => {
    if (item.stock <= 0) return { label: 'Sin Stock', color: 'bg-red-100 text-red-700' };
    if (item.stock <= item.min_stock) return { label: 'Stock Bajo', color: 'bg-orange-100 text-orange-700' };
    return { label: 'OK', color: 'bg-emerald-100 text-emerald-700' };
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-stone-900">Control de Inventario</h1>

      {/* Summary Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white rounded-2xl p-6 border border-stone-200">
          <p className="text-sm text-stone-500">Total Productos</p>
          <p className="text-2xl font-bold text-stone-900">{inventory.summary?.total_products || inventory.items?.length || 0}</p>
        </div>
        <div className="bg-orange-50 rounded-2xl p-6 border border-orange-200">
          <p className="text-sm text-orange-600">Stock Bajo</p>
          <p className="text-2xl font-bold text-orange-700">{inventory.summary?.low_stock_count || 0}</p>
        </div>
        <div className="bg-red-50 rounded-2xl p-6 border border-red-200">
          <p className="text-sm text-red-600">Sin Stock</p>
          <p className="text-2xl font-bold text-red-700">{inventory.summary?.out_of_stock_count || 0}</p>
        </div>
        <div className="bg-emerald-50 rounded-2xl p-6 border border-emerald-200">
          <p className="text-sm text-emerald-600">Valor Total</p>
          <p className="text-2xl font-bold text-emerald-700">
            ${(inventory.summary?.total_value || 0).toLocaleString()}
          </p>
        </div>
      </div>

      {/* Low Stock Alert */}
      {inventory.summary?.low_stock_count > 0 && (
        <div className="bg-orange-50 border border-orange-200 rounded-2xl p-4 flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-orange-600" />
          <p className="text-orange-800">
            Hay {inventory.summary.low_stock_count} productos con stock bajo que requieren atención
          </p>
        </div>
      )}

      {/* Inventory Table */}
      <div className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-stone-50 border-b border-stone-200">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Producto</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Stock</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Mínimo</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Estado</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Precio</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-stone-600">Costo</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {inventory.items?.map(item => {
                const status = getStockStatus(item);
                return (
                  <tr key={item.product_id} className="hover:bg-stone-50">
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-stone-100 rounded-lg flex items-center justify-center">
                          <Box className="w-5 h-5 text-stone-400" />
                        </div>
                        <span className="font-medium text-stone-900">{item.name}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 font-semibold text-stone-900">{item.stock}</td>
                    <td className="px-4 py-3 text-stone-500">{item.min_stock}</td>
                    <td className="px-4 py-3">
                      <Badge className={status.color}>{status.label}</Badge>
                    </td>
                    <td className="px-4 py-3 text-stone-700">${item.price?.toLocaleString()}</td>
                    <td className="px-4 py-3 text-stone-500">${item.cost?.toLocaleString()}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {(!inventory.items || inventory.items.length === 0) && (
          <div className="text-center py-12 text-stone-500">
            No hay productos en inventario
          </div>
        )}
      </div>
    </div>
  );
}
